import { render } from "./TrainingCompanies.vue?vue&type=template&id=3312f92e"
import script from "./TrainingCompanies.vue?vue&type=script&lang=js"
export * from "./TrainingCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__